// Angular
import { Component, EventEmitter, Input, OnInit, Output, } from '@angular/core';
import { FormGroup } from '@angular/forms';
// Afidium
import { IMenuItem, IPopupMenuConfig } from 'libraries/component/popup-menu/popup-menu.component';
import { TEMPLATE_LABELS } from "app_sasha/shared/config/booking-wording";
import { Yii } from "libraries/interfaces/Yii";
import { IMultiselectOptions } from "libraries/module/formbuilder/fields/multiselect/multiselect.model";
import { HelperService } from "app_sasha/shared/services/helper.service";
import { ConfigFieldBuilderService } from "../booking-search-form/config-field-builder.service";
import { IFieldSpecs } from "libraries/module/formbuilder/fields/interfaces/field-specs";
import { AFIDIUM_SERVICE_ARRAY_FIELDS, AFIDIUM_SERVICE_DATE_FIELDS } from "../booking-search-form/config";
import { ApiEligibility } from "libraries/service/resources/booking/interfaces/ApiSearchParameters";
import { BookingService } from 'libraries/service/booking/booking.service';
import { EnumsResourceService } from "libraries/service/booking/enums/enums-resource.service";
import { OperationStatus } from "libraries/service/resources/model/search/IBooking";
import { IGetEnumsAfidiumService } from "libraries/service/booking/enums/IGetEnums";
import { IDateRange } from "libraries/service/resources/model/search/IDateRange";
import { ILabels } from "libraries/interfaces/ILabels";
import { RuntimeError } from "libraries/service/error-tracing/runtime-error.model";
import { ErrorTracingService } from "libraries/service/error-tracing/error-tracing.service";
import { BookingSearchParameters } from 'libraries/interfaces/IBookingSearchParameters';
//libs
import { faTrash, IconDefinition } from "@fortawesome/free-solid-svg-icons";

export enum OptionConfigTypes {
    DateRange = 'DateRange',
}

interface IFieldConfig {
    [name: string]: IFieldSpecs;
}

export interface IOptionsConfig {
    label: string;
    optionConfig: IOptionConfig[];
}

export interface IOptionConfig {
    label: string;
    type: OptionConfigTypes;
    fieldConfig: object; // depends of the field type
    formControl: string;
    active?: boolean;
}

export interface ILabelAndValue {
    label: string;
    value: string;
}

@Component({
    selector: 'afidium-service-field',
    template: `
        <div class="mainBlock">
            <div class="bloc" *ngFor="let option of optionsConfig.optionConfig;">
                <div class="item">

                    <div class="col-to-row-s-tb">
                        <div class="sep-top flex-2">
                            <multiselect
                                    [fieldConfig]="formFields.serviceCodes"
                                    [options]="serviceOptions">
                            </multiselect>
                        </div>
                        <div class="whitespace">
                            <btnForm class="remove-button"
                                     *ngIf="activeItems > 0"
                                     styleType="actionLink"
                                     (keydown.enter)="removeField()"
                                     (click)="removeField()">
                                <fa-icon [icon]="iconTrash"></fa-icon>
                            </btnForm>
                        </div>
                    </div>

                </div>
                <div class="item">
                    <div class="col-to-row-s-tb">
                        <div class="flex-1 sep-top">
                            <multiselect
                                    [fieldConfig]="formFields.eligibilityStatuses"
                                    [options]="eligibilityOptions">
                            </multiselect>
                        </div>
                    </div>
                    <div class="whitespace">

                    </div>
                </div>

            </div>

        </div>

    `,
    styleUrls: ['./afidium-service-field.scss']
})

export class AfidiumServiceFieldComponent implements OnInit {

    @Input()
    public form: FormGroup;
    @Input()
    public index: number;

    @Output()
    public readonly onFormArrayRemoved: EventEmitter<number> = new EventEmitter<number>();

    public optionsConfig: IOptionsConfig;
    public menuConfig: IPopupMenuConfig;
    public activeItems: number = 0;
    public labels: ILabels = {
        remove: Yii.t('wui-sasha-js', "Supprimer le service"),
    };

    // Multiselect
    public formFields: IFieldConfig;
    public eligibilityOptions: IMultiselectOptions[];
    public treatmentOptions: IMultiselectOptions[];
    public serviceOptions: IMultiselectOptions[];

    public iconTrash: IconDefinition = faTrash;

    constructor(
        private readonly configFieldBuilderService: ConfigFieldBuilderService,
        private readonly helperService: HelperService,
        private readonly bookingService: BookingService,
        private readonly enumsResourceService: EnumsResourceService,
        private readonly errorTracingService: ErrorTracingService,
    ) {
    }


    public ngOnInit(): void {
        this.formFields = {
            ...this.configFieldBuilderService.buildFieldConfigArray(this.form, AFIDIUM_SERVICE_ARRAY_FIELDS),
            ...this.configFieldBuilderService.buildFieldConfigDate(this.form, AFIDIUM_SERVICE_DATE_FIELDS)
        };

        this.optionsConfig = {
            label: TEMPLATE_LABELS.afidiumServiceField,
            optionConfig: AFIDIUM_SERVICE_DATE_FIELDS
                .map((fieldName: BookingSearchParameters) => this.configFieldBuilderService.createDateRangeOptionConfig(fieldName, this.formFields)),
        };

        this.initMenuConfig();
        // get connectors to fill afidium service options array
        this.initServiceList();

        this.eligibilityOptions = this.helperService.getMultiselectOptions(
            this.bookingService.eligibilityLabels,
            Object.values(ApiEligibility),
            true
        );

        this.treatmentOptions = this.helperService.getMultiselectOptions(
            this.bookingService.operationLabels,
            Object.values(OperationStatus),
            false
        );

    }

    /**
     * @method initMenuConfig
     * @description initiate the menu config object
     */
    public initMenuConfig(): void {
        this.optionsConfig.optionConfig.forEach((config: IOptionConfig) => {
            const value: IDateRange = this.form.get(config.formControl).value;
            if (value && (value.min || value.max)) {
                config.active = true;
            }
        });

        const menuConfig: IMenuItem[] = this.optionsConfig.optionConfig
            .filter((config: IOptionConfig) => !config.active)
            .map((config: IOptionConfig) => {
                return {
                    label: config.label,
                    actionName: `ADD_${config.formControl.toUpperCase()}`
                };
            });

        this.menuConfig = {
            buttonLabel: this.optionsConfig.label,
            items: menuConfig,
        };

        this.getActiveItems();
    }


    /**
     * @method removeField
     * @description remove a targeted field from the list
     */
    public removeField(): void {
        this.onFormArrayRemoved.emit(this.index);
        this.initMenuConfig();
    }

    public initServiceList(): void {
        this.enumsResourceService.listAfidiumServices().subscribe((serviceInfomation: IGetEnumsAfidiumService[]) => {
                const serviceList: ILabelAndValue[] = [];
                for (const service of serviceInfomation) {
                    const addData: ILabelAndValue = {
                        label: service.name,
                        value: service.code,
                    };
                    serviceList.push(addData);
                }
                this.serviceOptions = serviceList;
            },
            (error: Error) => {
                this.errorTracingService.captureException(new RuntimeError("Unable to retrieve the list of available AfidiumServices.", error));
                this.serviceOptions = [];
            });
    }

    private getActiveItems(): void {
        let count: number = 0;
        this.optionsConfig.optionConfig
            .forEach((config: IOptionConfig) => {
                if (config.active) {
                    count = count + 1;
                }
            });
        this.activeItems = count;
    }
}
